import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import { RemoteFetchCustomerTypes } from "../../data/usecases/remote-fetch-customer-types";
import { FetchCustomerTypes } from "../../domain/useages/fetch-customer-types";
import Endpoints from "../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../base";
import { Speciality } from "../../domain/models/speciality";
import { RemoteFetchProductsMaster } from "../../data/usecases/remote-fetch-products-master";
import { FetchProductsMaster } from "../../domain/useages/fetch-products-master";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface FetchProductsMasterInterface {
  productsMasterData: Speciality[];
  fetchProductsMaster: Function;
}

const initialStates = {
  productsMasterData: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchProductsMasterSlice: StateCreator<
FetchProductsMasterInterface
> = (set, get) => ({
  ...initialStates,
  fetchProductsMaster: async () => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchProductsMaster: FetchProductsMaster =
      new RemoteFetchProductsMaster(
        `${BASE_URL}${Endpoints.FETCH_PRODUCTS}`,
        axiosHttpClient
      );

    set(() => ({ productsMasterData: [] }));

    let result = await remoteFetchProductsMaster.fetch();
    if (result) {
      set(() => ({ productsMasterData: result.products }));
    }
  },
});
